<template>
  <div class="bg-white rounded-xl shadow-sm border border-gray-100 p-4 mb-6">
    <div class="flex flex-col lg:flex-row lg:items-center justify-between gap-4">
      <!-- Filtros Rápidos (Pills) -->
      <div class="flex items-center gap-2 overflow-x-auto pb-1 lg:pb-0">
        <span class="text-xs font-bold text-gray-400 uppercase tracking-wider whitespace-nowrap mr-1">
          <i class="fa fa-calendar-alt text-orange-500 mr-1" /> Período:
        </span>

        <button
          v-for="preset in presets"
          :key="preset.id"
          type="button"
          class="px-3 py-1.5 rounded-lg text-xs font-semibold whitespace-nowrap transition-all cursor-pointer"
          :class="[
            activePreset === preset.id
              ? 'bg-orange-500 text-white shadow-sm ring-2 ring-orange-200'
              : 'bg-gray-100 text-gray-600 hover:bg-gray-200 hover:text-gray-900'
          ]"
          @click="selectPreset(preset)"
        >
          {{ preset.label }}
        </button>
      </div>

      <!-- Selectores de Fechas Manuales -->
      <form class="flex flex-wrap sm:flex-nowrap items-center gap-2" @submit.prevent="applyFilter">
        <div class="flex items-center gap-2">
          <div class="relative">
            <span class="absolute inset-y-0 left-0 pl-2.5 flex items-center pointer-events-none text-gray-400 text-xs">
              Desde:
            </span>
            <input
              v-model="localFrom"
              type="date"
              class="pl-14 pr-2.5 py-1.5 text-xs bg-gray-50 border border-gray-200 rounded-lg text-gray-700 font-medium focus:bg-white focus:outline-none focus:ring-2 focus:ring-orange-400 focus:border-transparent transition-all"
            />
          </div>

          <span class="text-gray-400 text-xs font-bold">-</span>

          <div class="relative">
            <span class="absolute inset-y-0 left-0 pl-2.5 flex items-center pointer-events-none text-gray-400 text-xs">
              Hasta:
            </span>
            <input
              v-model="localTo"
              type="date"
              class="pl-14 pr-2.5 py-1.5 text-xs bg-gray-50 border border-gray-200 rounded-lg text-gray-700 font-medium focus:bg-white focus:outline-none focus:ring-2 focus:ring-orange-400 focus:border-transparent transition-all"
            />
          </div>
        </div>

        <button
          type="submit"
          :disabled="loading"
          class="px-4 py-1.5 bg-orange-500 hover:bg-orange-600 active:bg-orange-700 text-white font-bold text-xs rounded-lg shadow-sm transition-all flex items-center gap-1.5 cursor-pointer disabled:opacity-50"
        >
          <i v-if="loading" class="fa fa-spinner fa-spin text-xs" />
          <i v-else class="fa fa-sync-alt text-xs" />
          <span>Consultar</span>
        </button>
      </form>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ReportDateFilter',

  props: {
    filters: {
      type: Object,
      required: true,
    },
    currentTab: {
      type: String,
      default: 'balance',
    },
  },

  data() {
    return {
      localFrom: this.filters.date_from || '',
      localTo: this.filters.date_to || '',
      activePreset: 'this_month',
      loading: false,
      presets: [
        { id: 'today', label: 'Hoy' },
        { id: 'last_7_days', label: '7 días' },
        { id: 'this_month', label: 'Este Mes' },
        { id: 'last_month', label: 'Mes Anterior' },
        { id: 'this_year', label: 'Este Año' },
      ],
    }
  },

  watch: {
    'filters.date_from'(val) {
      this.localFrom = val
      this.detectPreset()
    },
    'filters.date_to'(val) {
      this.localTo = val
      this.detectPreset()
    },
  },

  mounted() {
    this.detectPreset()
  },

  methods: {
    formatYmd(d) {
      const year = d.getFullYear()
      const month = String(d.getMonth() + 1).padStart(2, '0')
      const day = String(d.getDate()).padStart(2, '0')
      return `${year}-${month}-${day}`
    },

    selectPreset(preset) {
      this.activePreset = preset.id
      const now = new Date()

      let from = ''
      let to = this.formatYmd(now)

      if (preset.id === 'today') {
        from = to
      } else if (preset.id === 'last_7_days') {
        const d = new Date()
        d.setDate(d.getDate() - 6)
        from = this.formatYmd(d)
      } else if (preset.id === 'this_month') {
        const firstDay = new Date(now.getFullYear(), now.getMonth(), 1)
        from = this.formatYmd(firstDay)
      } else if (preset.id === 'last_month') {
        const firstDay = new Date(now.getFullYear(), now.getMonth() - 1, 1)
        const lastDay = new Date(now.getFullYear(), now.getMonth(), 0)
        from = this.formatYmd(firstDay)
        to = this.formatYmd(lastDay)
      } else if (preset.id === 'this_year') {
        const firstDay = new Date(now.getFullYear(), 0, 1)
        from = this.formatYmd(firstDay)
      }

      this.localFrom = from
      this.localTo = to
      this.applyFilter()
    },

    detectPreset() {
      const now = new Date()
      const todayStr = this.formatYmd(now)
      const firstThisMonth = this.formatYmd(new Date(now.getFullYear(), now.getMonth(), 1))

      if (this.localFrom === todayStr && this.localTo === todayStr) {
        this.activePreset = 'today'
      } else if (this.localFrom === firstThisMonth && this.localTo === todayStr) {
        this.activePreset = 'this_month'
      } else {
        this.activePreset = 'custom'
      }
    },

    applyFilter() {
      this.loading = true
      this.$inertia.get(
        '/reports',
        {
          date_from: this.localFrom,
          date_to: this.localTo,
          tab: this.currentTab,
        },
        {
          preserveState: true,
          preserveScroll: true,
          replace: true,
          onFinish: () => {
            this.loading = false
          },
        },
      )
    },
  },
}
</script>
